// JavaScript / React-compatible version of the Python function

function hashPassword(password) {
  const lettersDigitsChars =
    "a1b2c3d}4e5,f6g7h8{i9j0k.lAmBC/nD=oEpFqG]rHsItJuKvL\\wMxNyOz[P@Q#R$S_%T&!U^V*W(X)Y+Z";

  let newpass = "";

  // Check last character index parity
  if (lettersDigitsChars.indexOf(password[password.length - 1]) % 2 === 0) {
    const left = password.slice(0, Math.floor(password.length / 2));
    const right = password.slice(Math.floor(password.length / 2));
    newpass = right.slice(1) + left;
  } else {
    while (newpass.length < password.length) {
      let count1 = password.length - 1;
      while (count1 >= 0) {
        const idx = lettersDigitsChars.indexOf(password[count1]);
        if (idx !== -1) {
          if (lettersDigitsChars.length > idx + count1) {
            newpass += lettersDigitsChars[idx + count1];
          }
        }
        count1--;
      }
    }
  }

  let count = 0;
  while (count < password.length) {
    const idx = lettersDigitsChars.indexOf(password[count]);

    if (count % 2 === 0 && idx !== -1) {
      if (idx + password.length < lettersDigitsChars.length) {
        newpass += lettersDigitsChars[idx + password.length];
      }
    } else {
      if (idx !== -1) {
        let num =
          lettersDigitsChars.length -
          (password.length + count) -
          idx;
        num = Math.abs(num);
        newpass += String(num);
      }
    }

    count++;

    // Rotate halves
    const right = newpass.slice(0, Math.floor(newpass.length / 2));
    const left = newpass.slice(Math.floor(newpass.length / 2));
    newpass = left + right;
  }

  // Final split
  let right = newpass.slice(0, Math.floor(newpass.length / 2));
  let left = newpass.slice(Math.floor(newpass.length / 2));

  if (
    left.length > 5 &&
    right.length > 5 &&
    newpass.length < 40
  ) {
    left = hashPassword(left);
    right = hashPassword(right);
    newpass = left + right;
  }

  return newpass.slice(0, 50);
}

export default hashPassword;
